import {
  getRetailPurchaseApi, getRetailPurchaseUnProductApi, addRetailPurchaseApi, updateRetailPurchaseApi, delRetailPurchaseApi,
  getRetailProductOutApi, getRetailProductOutUnSellApi, addRetailProductOutApi, updateRetailProductOutApi, delRetailProductOutApi,
  getRetailProductInApi, getRetailProductInUnFinishProduct, addRetailProductInApi, updateRetailProductInApi, delRetailProductInApi,
  getRetailSellApi, addRetailSellApi, updateRetailSellApi, delRetailSellApi,
  getRetailFinanceApi, addRetailFinanceApi, updateRetailFinanceApi, delRetailFinanceApi,
  getRetailPurchaseInApi, addRetailPurchaseInApi, updateRetailPurchaseInApi, delRetailPurchaseInApi
} from '@/api/retail'

export const empty_purchase = {
  PurchaseDate: '', // 采购日期
  Procurementor: '', // 采购人员
  Supplier: '', // 供应商
  PlaceOfOrigin: '', // 产地
  FactoryNumber: '', // 厂号
  Cuts: '', // 部位
  UnitCostOfProduct: 0.0, // 产品单价
  ContractQuantity: 0.0, // 合同重量
  ContractValue: 0.0, // 合同金额
  FrontMoney: 0.0, // 实付定金
  DateOfPayment: '', // 付款日期

  ActualQuantity: 0.0, // 实发数量
  DeliveryDate: '', // 发货日期
  SettlementOfGoods: 0.0, // 货款结算
  BalanceDate: '', // 结算日期
  ReceivedQuantity: 0.0, // 收货重量
  ReceivedDate: '' // 收货日期
}

export const empty_purchase_in = {
  StorageDate: '', // 入库日期
  PlaceOfOrigin: '', // 产地
  FactoryNumber: '', // 厂号
  Cuts: '', // 部位
  ReceivedQuantity: 0.0, // 收货重量（KG）
  StorageNumber: '', // 入库箱号
  ProduceDate: '', // 生产日期
  QualityPeriod: '', // 保质期
  StorageManager: '' // 库管人员
}

export const empty_product_out = {
  PargetProduct: '', // 目标产品
  ProductNumber: '', // 产品编号
  ProductQuantity: 0.0, // 产品重量
  StorageNumber: '', // 入库编号
  InDate: '', // 入库日期
  ProducePerson: '', // 生产人员
  StorageManager: '' // 库管人员
}

export const empty_product_in = {
  ManufactureDate: '', // 生产日期
  ProducePerson: '', // 生产人员
  StorageNumber: '', // 出库箱号
  OrgStorageNumber: '', // 原始箱号
  ActualQuantity: 0.0, // 出库重量
  OutDate: '', // 出库日期
  ProductQuantity: 0.0, // 产品重量
  OtherQuantity: 0.0, // 边角料+肉沫重量
  LossQuantity: 0.0, // 重量损耗
  SteakRate: 0.0 // 牛排出成率
}

export const empty_sell = {
  SalesDate: '', // 销售日期
  Salesman: '', // 销售人员
  OrderNumber: '', // 订单号
  UnitCostOfProduct: 0.0, // 产品单价
  OrderValue: 0.0, // 订单金额
  OutDate: '', // 出库日期
  ProductNumber: '', // 出库产品编号
  ProductQuantity: 0.0, // 出库重量
  DeliveryDate: '', // 发货日期
  ExpressUnit: '', // 发货单位
  ExpressNumber: '', // 快递单号
  ReceivedDate: '', // 收货日期
  StorageManager: '' // 库管人员
}

export const empty_finance = {
  StatisticsDate: '', // 统计日期
  RawMaterialCosts: 0.0, // 原材料成本
  ProductionCosts: 0.0, // 生产成本
  LogisticsCosts: 0.0, // 物流成本
  OperatingCosts: 0.0, // 运营成本
  AmountSold: 0.0, // 销售金额
  Profit: 0.0, // 利润
  StatisticsPersson: '' // 统计人员
}

const retail = {
  state: {
    PurchaseTotal: 0,
    PurchaseList: [],
    PurchaseUnProductList: [],
    PurchaseEmptyTemplet: Object.assign({}, empty_purchase),
    PurchaseCurrent: Object.assign({}, empty_purchase),
    PurchaseQuery: {
      Page: 1,
      Offset: 0,
      PageSize: 20,
      SortOrder: '',
      SortField: '',
      KeyWord: ''
    },
    PurchaseInTotal: 0,
    PurchaseInList: [],
    PurchaseInUnProductList: [],
    PurchaseInEmptyTemplet: Object.assign({}, empty_purchase_in),
    PurchaseInCurrent: Object.assign({}, empty_purchase_in),
    PurchaseInQuery: {
      Page: 1,
      Offset: 0,
      PageSize: 20,
      SortOrder: '',
      SortField: '',
      KeyWord: ''
    },
    ProductOutTotal: 0,
    ProductOutList: [],
    ProductOutUnSellList: [],
    ProductOutEmptyTemplet: Object.assign({}, empty_product_out),
    ProductOutCurrent: Object.assign({}, empty_product_out),
    ProductOutQuery: {
      Page: 1,
      Offset: 0,
      PageSize: 20,
      SortOrder: '',
      SortField: '',
      KeyWord: ''
    },
    ProductInTotal: 0,
    ProductInList: [],
    ProductInUnFinishProductList: [],
    ProductInEmptyTemplet: Object.assign({}, empty_product_in),
    ProductInCurrent: Object.assign({}, empty_product_in),
    ProductInQuery: {
      Page: 1,
      Offset: 0,
      PageSize: 20,
      SortOrder: '',
      SortField: '',
      KeyWord: ''
    },
    SellTotal: 0,
    SellList: [],
    SellEmptyTemplet: Object.assign({}, empty_sell),
    SellCurrent: Object.assign({}, empty_sell),
    SellQuery: {
      Page: 1,
      Offset: 0,
      PageSize: 20,
      SortOrder: '',
      SortField: '',
      KeyWord: ''
    },
    FinanceTotal: 0,
    FinanceList: [],
    FinanceEmptyTemplet: Object.assign({}, empty_finance),
    FinanceCurrent: Object.assign({}, empty_finance),
    FinanceQuery: {
      Page: 1,
      Offset: 0,
      PageSize: 20,
      SortOrder: '',
      SortField: '',
      KeyWord: ''
    }
  },
  mutations: {
    SetRetailPurchaseList: (state, list) => {
      state.PurchaseList = list
    },
    SetRetailPurchaseUnProductList: (state, list) => {
      state.PurchaseUnProductList = list
    },
    SetRetailPurchaseTotal: (state, total) => {
      state.PurchaseTotal = total
    },
    SetRetailPurchaseCurrent: (state, current) => {
      state.PurchaseCurrent = current
    },
    SetRetailPurchaseInList: (state, list) => {
      state.PurchaseInList = list
    },
    SetRetailPurchaseInTotal: (state, total) => {
      state.PurchaseInTotal = total
    },
    SetRetailPurchaseInCurrent: (state, current) => {
      state.PurchaseInCurrent = current
    },
    SetRetailProductOutList: (state, list) => {
      state.ProductOutList = list
    },
    SetRetailProductOutUnSellList: (state, list) => {
      state.ProductOutUnSellList = list
    },
    SetRetailProductOutTotal: (state, total) => {
      state.ProductOutTotal = total
    },
    SetRetailProductOutCurrent: (state, current) => {
      state.ProductOutCurrent = current
    },
    SetRetailProductInList: (state, list) => {
      state.ProductInList = list
    },
    SetRetailProductInUnFinishProductList: (state, list) => {
      state.ProductInUnFinishProductList = list
    },
    SetRetailProductInTotal: (state, total) => {
      state.ProductInTotal = total
    },
    SetRetailProductInCurrent: (state, current) => {
      state.ProductInCurrent = current
    },
    SetRetailSellList: (state, list) => {
      state.SellList = list
    },
    SetRetailSellTotal: (state, total) => {
      state.SellTotal = total
    },
    SetRetailSellCurrent: (state, current) => {
      state.SellCurrent = current
    },
    SetRetailFinanceList: (state, list) => {
      state.FinanceList = list
    },
    SetRetailFinanceTotal: (state, total) => {
      state.FinanceTotal = total
    },
    SetRetailFinanceCurrent: (state, current) => {
      state.FinanceCurrent = current
    }
  },
  actions: {
    GetRetailPurchase({ commit, state }) {
      return new Promise((resolve, reject) => {
        let data = {}
        data = state.PurchaseQuery
        data.Offset = data.PageSize * (data.Page - 1)
        getRetailPurchaseApi(data).then(response => {
          commit('SetRetailPurchaseList', response.Data.Rows)
          commit('SetRetailPurchaseTotal', response.Data.Total)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetRetailPurchaseUnProduct({ commit, state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        getRetailPurchaseUnProductApi(data).then(response => {
          commit('SetRetailPurchaseUnProductList', response.Data.Rows)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddRetailPurchase({ state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        data.Model = state.PurchaseCurrent
        addRetailPurchaseApi(data).then(response => {
          state.PurchaseCurrent = Object.assign({}, empty_purchase)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateRetailPurchase({ state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        data.Model = state.PurchaseCurrent
        updateRetailPurchaseApi(data).then(response => {
          state.PurchaseCurrent = Object.assign({}, empty_purchase)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    DelRetailPurchase({ state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        data.IDs = []
        data.IDs.push(state.PurchaseCurrent.RetailPurchaseID)
        delRetailPurchaseApi(data).then(response => {
          state.PurchaseCurrent = Object.assign({}, empty_purchase)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetRetailPurchaseIn({ commit, state }) {
      return new Promise((resolve, reject) => {
        let data = {}
        data = state.PurchaseInQuery
        data.Offset = data.PageSize * (data.Page - 1)
        getRetailPurchaseInApi(data).then(response => {
          commit('SetRetailPurchaseInList', response.Data.Rows)
          commit('SetRetailPurchaseInTotal', response.Data.Total)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddRetailPurchaseIn({ state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        data.Model = state.PurchaseInCurrent
        addRetailPurchaseInApi(data).then(response => {
          state.PurchaseInCurrent = Object.assign({}, empty_purchase_in)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateRetailPurchaseIn({ state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        data.Model = state.PurchaseInCurrent
        updateRetailPurchaseInApi(data).then(response => {
          state.PurchaseInCurrent = Object.assign({}, empty_purchase_in)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    DelRetailPurchaseIn({ state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        data.IDs = []
        data.IDs.push(state.PurchaseInCurrent.RetailPurchaseInID)
        delRetailPurchaseInApi(data).then(response => {
          state.PurchaseInCurrent = Object.assign({}, empty_purchase_in)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetRetailProductOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        let data = {}
        data = state.ProductOutQuery
        data.Offset = data.PageSize * (data.Page - 1)
        getRetailProductOutApi(data).then(response => {
          commit('SetRetailProductOutList', response.Data.Rows)
          commit('SetRetailProductOutTotal', response.Data.Total)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetRetailProductOutUnSellApi({ commit, state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        getRetailProductOutUnSellApi(data).then(response => {
          commit('SetRetailProductOutUnSellList', response.Data.Rows)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddRetailProductOut({ state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        data.Model = state.ProductOutCurrent
        console.log(data)
        addRetailProductOutApi(data).then(response => {
          state.ProductOutCurrent = Object.assign({}, empty_product_out)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateRetailProductOut({ state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        data.Model = state.ProductOutCurrent
        updateRetailProductOutApi(data).then(response => {
          state.ProductOutCurrent = Object.assign({}, empty_product_out)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    DelRetailProductOut({ state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        data.IDs = []
        data.IDs.push(state.ProductOutCurrent.RetailProductOutID)
        delRetailProductOutApi(data).then(response => {
          state.ProductOutCurrent = Object.assign({}, empty_product_out)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetRetailProductIn({ commit, state }) {
      return new Promise((resolve, reject) => {
        let data = {}
        data = state.ProductInQuery
        data.Offset = data.PageSize * (data.Page - 1)
        getRetailProductInApi(data).then(response => {
          commit('SetRetailProductInList', response.Data.Rows)
          commit('SetRetailProductInTotal', response.Data.Total)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetRetailProductInUnFinishProduct({ commit, state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        getRetailProductInUnFinishProduct(data).then(response => {
          commit('SetRetailProductInUnFinishProductList', response.Data.Rows)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddRetailProductIn({ state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        data.Model = state.ProductInCurrent
        addRetailProductInApi(data).then(response => {
          state.ProductInCurrent = Object.assign({}, empty_product_in)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateRetailProductIn({ state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        data.Model = state.ProductInCurrent
        updateRetailProductInApi(data).then(response => {
          state.ProductInCurrent = Object.assign({}, empty_product_in)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    DelRetailProductIn({ state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        data.IDs = []
        data.IDs.push(state.ProductInCurrent.RetailProductInID)
        delRetailProductInApi(data).then(response => {
          state.ProductInCurrent = Object.assign({}, empty_product_in)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetRetailSell({ commit, state }) {
      return new Promise((resolve, reject) => {
        let data = {}
        data = state.SellQuery
        data.Offset = data.PageSize * (data.Page - 1)
        getRetailSellApi(data).then(response => {
          commit('SetRetailSellList', response.Data.Rows)
          commit('SetRetailSellTotal', response.Data.Total)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddRetailSell({ state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        data.Model = state.SellCurrent
        addRetailSellApi(data).then(response => {
          state.SellCurrent = Object.assign({}, empty_sell)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateRetailSell({ state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        data.Model = state.SellCurrent
        updateRetailSellApi(data).then(response => {
          state.SellCurrent = Object.assign({}, empty_sell)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    DelRetailSell({ state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        data.IDs = []
        data.IDs.push(state.SellCurrent.RetailSellID)
        delRetailSellApi(data).then(response => {
          state.SellCurrent = Object.assign({}, empty_sell)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetRetailFinance({ commit, state }) {
      return new Promise((resolve, reject) => {
        let data = {}
        data = state.FinanceQuery
        data.Offset = data.PageSize * (data.Page - 1)
        getRetailFinanceApi(data).then(response => {
          commit('SetRetailFinanceList', response.Data.Rows)
          commit('SetRetailFinanceTotal', response.Data.Total)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddRetailFinance({ state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        data.Model = state.FinanceCurrent
        addRetailFinanceApi(data).then(response => {
          state.FinanceCurrent = Object.assign({}, empty_finance)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateRetailFinance({ state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        data.Model = state.FinanceCurrent
        updateRetailFinanceApi(data).then(response => {
          state.FinanceCurrent = Object.assign({}, empty_finance)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    DelRetailFinance({ state }) {
      return new Promise((resolve, reject) => {
        const data = {}
        data.IDs = []
        data.IDs.push(state.FinanceCurrent.RetailFinanceID)
        delRetailFinanceApi(data).then(response => {
          state.FinanceCurrent = Object.assign({}, empty_finance)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default retail



// WEBPACK FOOTER //
// ./src/store/modules/retail.js